<template>
    <div class="_content">
        <div v-if="this.userRole === '老板' ">
            <!-- 添加收款银行卡信息 根据数据code切换-->
            <div v-if="!code" class="accounts_add_bank">
                <!-- 通知栏 -->
                <!--text="请准确填写开户支行等账户信息，否则由此造成收款失败等责任由商户自负。"  left-icon="warn-o" -->
                <div class="notice_bar">
                    <!-- left-icon="volume-o" -->
                    <van-notice-bar
                    class="accounts_notice-bar"
                    wrapable
                    :scrollable="false"
                    background="rgb(251,229,229)"
                    >
                    <img src="@/imgs/warning.png" alt="">
                    <span>请准确填写开户支行及联行号等账户信息（如不清楚可咨询银行客服或联系市场经理协助查询），否则由此造成收款失败等责任由商户自负。</span>
                    </van-notice-bar>
                </div>
                <!-- 添加银行卡信息 -->
                <div class="accounts_add_bankcar">
                    <!-- 开户银行 -->
                    <van-cell-group>
                        <!-- 输入框 -->
                        <van-field
                            readonly
                            clickable
                            label="开户银行"
                            :value="proceeds_val1"
                            placeholder="请选择"
                            @click="proceeds_Picker1 = true"
                            input-align="right"
                            is-link
                        />
                        <van-popup v-model="proceeds_Picker1" round position="bottom">
                            <!-- 选择器 -->
                            <van-picker show-toolbar 
                            title="请选择银行名称"
                            :columns="proceeds_columns1"
                            @cancel="proceeds_Picker1 = false"
                            @confirm="proceeds_onConfirm1"
                            />
                        </van-popup>
                    </van-cell-group>

                    <van-cell-group>
                        <van-field
                            input-align="right" 
                            v-model="proceeds_val2"
                            label="开户支行" 
                            placeholder="请输入" 
                        />
                    </van-cell-group>
                    
                    <van-cell-group>
                        <van-field 
                            input-align="right" 
                            v-model="proceeds_val3" 
                            label="收款人姓名" 
                            placeholder="请输入" 
                            maxlength="50"
                            :formatter="formatterAccountName"
                        />
                    </van-cell-group>

                    <van-cell-group>
                        <van-field
                            input-align="right" 
                            v-model="proceeds_val6"
                            label="身份证号码" 
                            placeholder="请输入" 
                        />
                    </van-cell-group>

                    <van-cell-group>
                        <van-field 
                            input-align="right" 
                            v-model="proceeds_val4" 
                            label="银行账号" 
                            placeholder="请输入" 
                            maxlength="19"
                            :formatter="formatter1" 
                        />
                    </van-cell-group>

                    <van-cell-group>
                        <van-field 
                            input-align="right" 
                            v-model="proceeds_val7" 
                            class="w100"
                            label="收款人手机号码" 
                            placeholder="请输入收款人实名认证手机号码" 
                            maxlength="19"
                            :formatter="formatter1" 
                        />
                    </van-cell-group>

                    <van-cell-group>
                        <van-field 
                            input-align="right" 
                            v-model="proceeds_val5" 
                            label="联行号" 
                            placeholder="请输入联行号（可咨询银行客服或联系市场经理协助查询）" 
                            :class="['custom-placeholder',proceeds_val5?'':'custom-placeholder1']"
                        />
                    </van-cell-group>
                </div>
                <div>
                    <van-button 
                        class="add_bankcar_btn" 
                        @click="isDisabled ? handleClick(tabList1[0]) :'' "
                        size="large" 
                        type="info"
                    >保存
                    </van-button>
                </div>
            </div>

            <!-- 银行卡信息 -->
            <div v-if="code" class="accounts_show_bank">
                <!-- 通知栏 -->
                <div class="notice_bar">
                    <!-- left-icon="volume-o" -->
                    <van-notice-bar
                    class="accounts_notice-bar"
                    wrapable
                    :scrollable="false"
                    background="rgb(251,229,229)"
                    >
                        <img src="@/imgs/warning.png" alt="">
                        <span>如需更改收款账户信息，请联系市场经理</span>
                    </van-notice-bar>
                </div>
                <!-- 收款账户 银行卡 -->
                <div class="proceeds_bank"  >
                    <van-icon  name="credit-pay" color="#fff" size="3rem" />
                    <div>
                        <span>{{bankInfoData.bankName}}</span>
                        <span>{{bankInfoData.bankBranchName}}</span>
                        <span>{{bankInfoData.bankAccountName}}</span>
                        <span>{{bankInfoData.bankAccount}}</span>
                        <span>{{bankInfoData.bankAccountNumber}}（联行号）</span>
                    </div>
                </div>
                <!-- 联系市场经理 -->
                <div class="proceeds_btn">
                    <van-button v-call="'400-176-8848'" class="proceeds_phoneicon add_bankcar_btn" url="" to="" size="large" type="info">
                        <van-icon  name="phone" color="#fff"  />
                        <span>联系市场经理</span> 
                    </van-button>
                </div>
            </div>
        </div>

        <van-empty 
            v-else-if="this.userRole === '店长' || this.userRole === '员工' || this.userRole === '' "
            image="error" 
            description="权限不足或网络错误" 
        />

    </div>
</template>
<script>
import config from '@/configs/config'
import * as _ from 'lodash'
import util from '@/commons/util'
export default {
        components: {
    },
    data() {
        return {
            bankInfoData: {},
            checked: true,
            proceeds_val1: '',
            proceeds_val2: '',
            proceeds_val3: '',
            proceeds_val4: '',
            proceeds_val5:'',
            proceeds_val6:'',
            proceeds_val7: '',
            proceeds_Picker1: false,
            proceeds_columns1: ['中国银行', '中国工商银行', '中国农业银行', '中国建设银行', '交通银行', '中国邮政储蓄银行'],
            active: 2,
            title: '',
            tabList1: [{
                    name: '收款账户',
                    url: '/pages/accounts/index'
            }],
            code: null,
            userRole: '',
            shopId: '',
            isDisabled: true
        }
    },
    created() {
        this.getBankInfo()
    },
    methods: {
        proceeds_onConfirm1(value) {
            this.proceeds_val1 = value.toString()
            this.proceeds_Picker1 = false
        },
        async getBankInfo() {
            // 身份信息
            const roleData = await tuhu.fetch(`${config.apis.GET_USERINFO}`)
            if (roleData && roleData.code === '200') {
                this.userRole = roleData.data.role
                this.shopId = roleData.data.shopId
            } else {
                tuhu.toast(roleData.message || '获取权限失败')
            }
            // 银行卡信息
            const data = await tuhu.fetch(`${config.apis.PROCEEDS_BANKCAR_INFO}`, {
                method: 'post',
                body: JSON.stringify({
                    shopId: this.shopId
                })
            })
            if (data && data.code === '200') {
                // 0 是有数据页
                // if (data.data === null) {
                //     this.code = 1
                // } else {
                //     this.bankInfoData = data.data
                //     this.code = 0
                // }
                this.code=data.data.isCheck
                this.bankInfoData = data.data
                this.proceeds_val1=this.bankInfoData.bankName
                this.proceeds_val2=this.bankInfoData.bankBranchName
                this.proceeds_val3=this.bankInfoData.bankAccountName
                this.proceeds_val4=this.bankInfoData.bankAccount
                this.proceeds_val5=this.bankInfoData.bankAccountNumber
                this.proceeds_val6=this.bankInfoData.bankAccountIdCard
                this.proceeds_val7=this.bankInfoData.phone
            } else {
                tuhu.toast(data.message || '网络错误')
            }
            // 银行列表
            if (!this.code) {
                const bankList = await tuhu.fetch(`${config.apis.GET_BANK_LIST}?level=1&type=3`)
                if (bankList && bankList.code === '200') {
                    let bankArr = []
                    for (let i = 0; i < bankList.data.length; i++) {
                        let bankName = bankList.data[i].text.replace(/股份/g, '').replace(/有限/g, '').replace(/公司/g, '')
                        bankArr.push(bankName)
                    }
                    this.proceeds_columns1 = bankArr
                } else {
                    tuhu.toast(bankList.message || '网络错误')
                }
            }
        },
        async handleClick(item) {
            this.proceeds_val4=String(this.proceeds_val4).replace(/\s+/g, '')//除去空格
            if(!this.proceeds_val1) return tuhu.toast('请选择开户银行')
            if(!this.proceeds_val2) return tuhu.toast('请输入开户支行')
            if(!this.proceeds_val3) return tuhu.toast('请输入收款人姓名')
            let nameReg = /^[\u4e00-\u9fa5·（）]+$/
            if(!nameReg.test(this.proceeds_val3)) return tuhu.toast('收款人姓名仅支持中文、括号和点')
            if(!this.proceeds_val4) return tuhu.toast('请输入银行账号')
            let reg=/^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
            if(this.proceeds_val6&&!reg.test(this.proceeds_val6))return tuhu.toast('请输入有效的身份证号码')
            if (!util.isPhone(this.proceeds_val7)) return tuhu.toast('请输入正确的手机号')
            //if(!this.proceeds_val5) return tuhu.toast('请输入联行号')
            if(!this.isDisabled)return
            this.isDisabled = false
            let data = await tuhu.fetch(`${config.apis.PROCEEDS_CHANGE_BANKCAR_INFO}`, {
                method: 'post',
                body: JSON.stringify({
                    'bankCardInfo': {
                        'bankName': this.proceeds_val1, // 银行名
                        'bankBranchName': this.proceeds_val2, // 支行名
                        'bankAccountName': this.proceeds_val3,  // 账户名
                        'bankAccount': this.proceeds_val4,  // 银行账户号
                        'bankAccountNumber':this.proceeds_val5,//联行号
                        bankAccountIdCard:this.proceeds_val6,
                        phone:this.proceeds_val7,
                    },
                    'shopId': this.shopId
                })
            })
            this.isDisabled=true
            if (data && data.code === '200') {
                // this.isDisabled = false
                // tuhu.navigateTo({
                //     url: item.url
                // })
                if(this.proceeds_val1&&this.proceeds_val2&&this.proceeds_val3&&this.proceeds_val4&&this.proceeds_val5) {
                    this.code=null
                    this.getBankInfo()
                }
            } else {
                tuhu.toast(data.message || '网络错误')
            }
        },
        formatter1(value) {
            return value.replace(/\W/ig, '')
        },
        formatterAccountName(value) {
            return value.replace(/[^\u4e00-\u9fa5·（）]/g, '')
        },
        formatter2(value) {
            return value.replace(/\W/ig, '')
        }
    }
}
</script>
<style lang="less" scoped >
    .proceeds_bank{
        display: flex;
        flex-direction: row;
        background: red;
        width: 17rem;
        height: 7rem;
        margin: .5rem auto 3rem;
        border-radius: 5px;
        .van-icon{
            padding-top: 1rem;
        }
        >div{
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            color: #fff;
            padding-left: .3rem;
            span:nth-child(1) {
                font-size: .9rem;
            }
        }
    }
    .notice_bar{
        width: 100%;
        /deep/.van-notice-bar__content{
        display: flex;
        flex-direction: row;
        align-items: center;
        }
        img{
            width: 1rem;
            height: 1rem;
            margin-right: .5rem ;
        }
    }
    /deep/.van-notice-bar__content{
        color: #f00;
    }
    .accounts_add_bank{
        display: flex;
        flex-direction: column;
        align-items: center;
        .accounts_add_bankcar{
            width: 17.5rem;
            border-radius: .25rem;
            margin: .5rem 0 0;
        }
    }
    .accounts_show_bank{
        display: flex;
        flex-direction: column;
        align-items: center;
        
    }
    .add_bankcar_btn{
        .van-button__text{
            color: #fff;
            .van-icon {
            font-size: 1rem;
            margin-right: .2rem;
        }
        display:flex;
        justify-content:center;
        align-items:center;
        }
    }
    .custom-placeholder{
        padding: 0 16px;
        height: 50px;
        line-height: 50px;
        display: flex;
        align-items: center;
        /deep/.van-field__control{
            height: 50px;
            &::placeholder{
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    display: -moz-box;
                    -moz-line-clamp: 2;
                    -moz-box-orient: vertical;
                    overflow-wrap: break-word;
                    word-break: break-all;
                    white-space: normal;
                    overflow: hidden;
                    font-size: .6rem;
                }
            }    
    }
    .custom-placeholder1{
        /deep/.van-field__control{
            padding-bottom: 10px;
        }
    }
    /deep/.w100{
        .van-cell__title{
            width: 5rem;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/accounts/index.vue